import ReportsBox from '../../components/admin/ReportsBox'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

const Reports = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Reports'}>
          <ReportsBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default Reports
